import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DynamicEntityInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('dynamic-entity')) {
      const headerValue = "863ee8c11f094066e259a154349047a04c7d3804a5f66aa88c0e20d2eef56ec0";
      request = request.clone({ setHeaders: { "ApiSyncToken": headerValue } });
    }
    
    return next.handle(request);
  }
}
